import { Component } from '@angular/core';
import { HotToastService } from '@ngxpert/hot-toast';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AdminService } from '../../../services/admin.service';


@Component({
  selector: 'app-repo-request',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule, SpinnerComponent, NgxPaginationModule, SearchFilterPipe, RouterOutlet, NgSelectModule],
  templateUrl: './repo-request.component.html',
  styles: ``
})
export class RepoRequestComponent {

    //Common Variables
    pageName: string = ''
    user: any;
    userMail: any;
    requestForm = this.formBuilder.group({
      projectName: [],
      organization: ['', [Validators.required]],
      approver: [''],
    })
  
    constructor(
      private readonly titleService: Title,
      private readonly toast: HotToastService,
      private readonly adminService: AdminService,
      public formBuilder: FormBuilder,
      private readonly route: ActivatedRoute) {
      this.pageName = this.route.snapshot.data['name'];
      let getJson = localStorage.getItem('userData') as string;
      this.user = JSON.parse(getJson);
      this.userMail = this.user.email
    }
  
    ngOnInit(): void {
      this.titleService.setTitle(`QMigrator - ${this.pageName}`);
      this.getAdmins();
      this.getOrg();
    }

    get f():any{ return this.requestForm.controls}

    projectData: any;
    getProjects(org: any) {
      this.projectData = [];
      this.adminService.fetchProjects(org).subscribe((data: any) => {
        this.projectData = data.value;
      });
    }
    adminUserData: any;
    getAdmins() {
      this.adminService.getAdmins().subscribe((data: any) => {
        this.adminUserData = data['Table'];
      });
    }
    orgUserData: any = [];
    exist: any = [];
    res: any = [];
    spin_req: boolean = false;
    organization: any;
    requestAccess(formData: any) {
      this.spin_req = true;
      this.organization = formData.organization;
      this.adminService.getUsers(formData.organization).subscribe((reqdata: any) => {
        this.orgUserData = reqdata;
        this.exist = this.orgUserData.filter((item: any) => {
          return item.principalName == this.userMail;
        });
        if (this.exist.length == 1) {
          let obj = {
            requester: this.userMail,
            organization: formData.organization,
            project: formData.projectName,
            approver: formData.approver,
            status: 'Requested',
          };
          this.adminService.repoRequest(obj).subscribe((data: any) => {
            this.res = data.message;
            this.spin_req = false;
            this.toast.success(data.message);
          });
        } else {
          this.toast.warning('You are Not the User Of QMigratoeWeb');
        }
      });
    }
    orgData: any;
    getOrg() {
      this.adminService.fetchOrganization().subscribe((data: any) => {
        this.orgData = data['Table'];
      });
    }
}
